"use client"

import { DocsIcon } from "@src/icons"

export const DocsButton = () => {
  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== "undefined" && window.Beacon) {
          window.Beacon("navigate", "/answers/")
          window.Beacon("open")
        }
      }}
      className="flex size-11 shrink-0 items-center justify-center rounded-lg bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-gray-300 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
    >
      <DocsIcon className="size-5 shrink-0" />
      <span className="sr-only">Docs</span>
    </button>
  )
}
